import EditTimeSlotDialog from "../dashboard/Appointment/EditTimeSlotDialog";
import RejectAppointmentDialog from "./dialogs/RejectAppointmentDialog";
import RejectAllAppointments from "./dialogs/rejections/allReject";
import { hideDialog } from "../../redux/guest-slices/other.slice";
import CreateAppointment from "./dialogs/appointment/create";
import Exception from "./dialogs/availability/exception";
import UploadDocuments from "./dialogs/UploadDocuments";
import { useDispatch, useSelector } from "react-redux";
import Availability from "./dialogs/availability";
import WebnarCreate from "./dialogs/WebnarCreate";
import ManageCookie from "./dialogs/ManageCookie";
import Reject from "./dialogs/rejections/reject";
import Appointment from "./dialogs/Appointment";
import Testimonial from "./dialogs/Testimonial";
import CheckEmail from "./dialogs/CheckEmail";
import FollowupLink from "./dialogs/Followup";
import ChatWarn from "./dialogs/ChatWarn";
import Booking from "./dialogs/Booking";
import { Dialog } from "@mui/material";
import Delete from "./dialogs/Delete";
import Report from "./dialogs/Report";
import Signup from "./dialogs/Signup";
import Login from "./dialogs/Login";
import AppointmentDetails from "./dialogs/AppointmentDetails";

import {
  CHECK_EMAIL,
  GUEST_LOGIN,
  MANAGE_COOKIE,
  COMMENT_REPORT,
  TESTIMONIAL_VIDEO,
  GUEST_SIGNUP,
  CREATE_BOOKING,
  FORUM_REPORT,
  WEBINAR_CREATE,
  EDIT_TIME_SLOT,
  APPOINTMENT_REJECT,
  FOLLOW_UP,
  UPLOAD_DOC,
  REJECT_APPOINTMENT,
  DELETE_SCHEDULE,
  REJECT_ALLAPPOINTMENTS,
  DAILY_CHAT_WARN,
  APPOINTMENT_SCHEDULE,
  CANCEL_APPOINTMENT,
  UPDATE_AVAILABILITY_SLOT,
  ADD_EXCEPTION,
  APPOINTMENT_SLOTS,
  APPOINTMENT_COMPLETE_POPUP,
  APPOINTMENT_CANCEL_CONFIRM,
  SUBSCRIPTION_CHECKOUT,
  FEATURE_GUARD,
  APPOINTMENT_DETAILS
} from "../../utils/keywords";
import AppointmentCompletePopup from "./dialogs/AppointmentCompletePopup";
import AppointmentCancelConfirm from "./dialogs/AppointmentCancelConfirm";
import SubscriptionCheckoutDialog from "./dialogs/SubscriptionCheckoutDialog";
import FeatureGuardDialog from "./dialogs/FeatureGuardDialog";

function DialogContainer() {
  const dispatch = useDispatch();
  const { show, type } = useSelector((state) => state.otherSlice);

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog());
  };
  return (
    <Dialog
      sx={{
        "& .MuiBackdrop-root": {
          opacity: "0.5 !important",
          backgroundColor: "#00000080",
          backdropFilter: "blur(4px)",
        },
      }}
      fullWidth
      open={show}
      scroll="paper"
      translate="yes"
      id="#MuiDialog"
      onClose={type === TESTIMONIAL_VIDEO ? handleClose : null}
      maxWidth={
        type === TESTIMONIAL_VIDEO
          ? "xxl"
          : type === MANAGE_COOKIE || type === APPOINTMENT_DETAILS
            ? "sm"
            : type === REJECT_ALLAPPOINTMENTS
              ? "md"
              : "xs"
      }
    >
      {type === GUEST_LOGIN && <Login />}
      {type === FORUM_REPORT && <Report />}
      {type === GUEST_SIGNUP && <Signup />}
      {type === COMMENT_REPORT && <Report />}
      {type === DELETE_SCHEDULE && <Delete />}
      {type === CHECK_EMAIL && <CheckEmail />}
      {type === CREATE_BOOKING && <Booking />}
      {type === FOLLOW_UP && <FollowupLink />}
      {type === MANAGE_COOKIE && <ManageCookie />}
      {type === WEBINAR_CREATE && <WebnarCreate />}
      {type === EDIT_TIME_SLOT && <EditTimeSlotDialog />}
      {type === APPOINTMENT_REJECT && <RejectAppointmentDialog />}
      {type === APPOINTMENT_SCHEDULE && <Appointment />}
      {type === DAILY_CHAT_WARN && <ChatWarn handleClose={handleClose} />}
      {type === UPLOAD_DOC && <UploadDocuments handleClose={handleClose} />}
      {type === UPDATE_AVAILABILITY_SLOT && <Availability handleClose={handleClose} />}
      {type === ADD_EXCEPTION && <Exception handleClose={handleClose} />}
      {type === APPOINTMENT_SLOTS && <CreateAppointment handleClose={handleClose} />}
      {(type === REJECT_ALLAPPOINTMENTS) && (
        <RejectAllAppointments handleClose={handleClose} />
      )}
      {type === APPOINTMENT_COMPLETE_POPUP && <AppointmentCompletePopup />}
      {(type === REJECT_APPOINTMENT || type === CANCEL_APPOINTMENT) && <Reject handleClose={handleClose} />}
      {type === TESTIMONIAL_VIDEO && <Testimonial handleClose={handleClose} />}
      {type === APPOINTMENT_CANCEL_CONFIRM && <AppointmentCancelConfirm/>}
      {type === SUBSCRIPTION_CHECKOUT && (<SubscriptionCheckoutDialog />)}
      {type === FEATURE_GUARD && (<FeatureGuardDialog />)}
      {type === APPOINTMENT_DETAILS && (<AppointmentDetails />)}
      
    </Dialog>
  );
}

export default DialogContainer;
